import React from 'react'
import Customers from '../Customers/Customers';

const CustomersList = _ => {
    return <>
        <Customers namePlural={"Clientes"} nameSingle="Cliente" showButttonAdd={false} typeList="CUSTOMERS_LIST" />
    </>
}

export default CustomersList